import React from "react";
import { Stack } from "expo-router/stack";

import { useSession } from "@/context/auth/useSession";
import LoadingScreen from "@/screens/Loading/LoadingScreen";
import MediaManagerHeader from "@/screens/MediaManager/MediaManagerHeader";
import ManagePermissionHeader from "@/screens/MediaPermission/ManagePermissionHeader";

export default function Layout(): React.JSX.Element {
  const { session } = useSession();

  if (session === null) {
    return <LoadingScreen />;
  }

  return (
    <Stack>
      <Stack.Screen
        name="home"
        options={{
          header: () => {
            return <MediaManagerHeader session={session} />;
          },
        }}
      />
      <Stack.Screen
        name="permissions"
        options={{
          header: () => {
            return <ManagePermissionHeader />;
          },
        }}
      />
    </Stack>
  );
}
